export default __webpack_public_path__ + "static/media/AMP - White.b27d9aee.png";